export const getters = {
  systemPettycashes: state => state.pettycashes,
  systemPetty: state =>  state.pettycash
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettycashes/getters.js